module.exports = __webpack_public_path__ + "img/static-job2@2x.2d02a439.png";